import { Box, Stack, Typography } from '@mui/material';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <Box sx={{ height: '100vh' }}>
      <Box sx={{ textAlign: 'left', padding: '60px 81px 0' }}>
        <Box
          component='img'
          src={'../images/logo.png'}
          sx={{ width: '314px', objectFit: 'contain' }}
        />
      </Box>
      <Stack
        justifyContent='center'
        alignItems='center'
        sx={{ width: '100%', height: 'calc(100% - 123px)' }}
      >
        <Typography
          sx={{
            color: '#1a96f0',
            fontSize: '50px',
            fontWeight: '700',
            textAlign: 'center',
            marginBottom: '27px',
          }}
        >
          ATTENDANCE BOARD
        </Typography>
        <Outlet />
      </Stack>
    </Box>
  );
};

export default AuthLayout;
